import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import { parseString } from 'xml2js'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  state: {
    started: false,
    moving: false,
    transition: 'fade',
    index: null,
    questions: [],
    answers: [],
    types: [],
    type: null,
  },
  getters: {
    initialized(state) {
      return state.questions.length > 0 && state.types.length > 0
    },
    screen(state) {
      if (state.index != null) {
        return 'question'
      }
      if (state.type) {
        return 'result'
      }
      return 'top'
    },
    question(state, getters) {
      if (state.index != null && state.answers[state.index]) {
        return getters.getQuestionById(state.answers[state.index].question)
      } else {
        return null
      }
    },
    prevQuestion(state, getters) {
      if (state.index != null && state.index > 0) {
        return getters.getQuestionById(state.answers[state.index - 1].question)
      } else {
        return null
      }
    },
    nextQuestion(state, getters) {
      if (state.index != null && state.index < state.answers.length - 1) {
        return getters.getQuestionById(state.answers[state.index + 1].question)
      } else {
        return null
      }
    },
    getQuestionById: state => id => {
      return state.questions.find(question => question.id == id)
    },
    getQuestionByLinkNo: state => linkNo => {
      return state.questions.find(question => question.linkNo == linkNo)
    },
    answers(state, getters) {
      return state.answers.filter(a => a.answer).map(a => {
        let question = getters.getQuestionById(a.question)
        return {
          answer: a.answer == 'yes' ? 'はい' : 'いいえ',
          question: question.title,
        }
      })
    },
    type(state, getters) {
      if (state.type != null) {
        return getters.getTypeById(state.type)
      } else {
        return null
      }
    },
    getTypeById: state => id => {
      return state.types.find(type => type.id == id)
    },
  },
  actions: {
    initialize({ commit }) {
      axios.get('/iekatsu/xml/info.xml', { responseType: 'text' })
        .then(response => {
          parseString(response.data, (error, result) => {
            let questions = result.data.question.map(question => {
              return {
                id: question.$.id,
                linkNo: question.$.linkNo,
                title: question.title[0],
                comment: {
                  yes: question.comment[0].yes[0],
                  no: question.comment[0].no[0],
                },
                link: {
                  yes: question.link[0].yes[0],
                  yesres: question.link[0].yesres ? question.link[0].yesres[0] : null,
                  no: question.link[0].no[0],
                  nores: question.link[0].nores ? question.link[0].nores[0] : null,
                },
                char_kind: {
                  yes: question.char_kind[0].yes[0],
                  no: question.char_kind[0].no[0],
                }
              }
            })
            commit('setQuestions', questions)
          })
        })
      axios.get('/iekatsu/xml/answer.xml')
        .then(response => {
          parseString(response.data, (error, result) => {
            let types = result.data.type.map(type => {
              return {
                id: type.$.id,
                title: type.title[0],
                lead: type.lead[0],
                jyunbi: type.jyunbi[0],
                sekkei: type.sekkei[0],
                kouji: type.kouji[0],
                all: type.all[0],
                notice: type.notic[0],
                pdf: type.pdf[0],
                print: type.prnt[0],
                answer: '/iekatsu/' + type.answr[0],
              }
            })
            commit('setTypes', types)
            types.forEach(type => {
              axios.get(type.answer, { responseType: 'text' })
                .then(response => {
                  commit('setTypeAnswer', {
                    id: type.id,
                    answer: response.data,
                  })
                })
            })
          })
        })
    },
    start({ commit, state, getters }) {
      commit('start')
      setTimeout(() => {
        let nextQuestion = getters.getQuestionByLinkNo(0)
        commit('addNextQuestion', {
          index: 0,
          question: nextQuestion.id,
        })
        commit('setIndex', 0)
      }, 1000)
    },
    answer({ commit, state, getters }, answer) {
      let { question } = getters
      if (question) {
        commit('setQuestionAnswer', {
          index: state.index,
          question: question.id,
          answer,
        })

        let linkNo = question.link[answer]
        if (linkNo != 'finish') {
          commit('transition', 'fade')
          Vue.nextTick().then(() => {
            commit('moving', true)
            let nextQuestion = getters.getQuestionByLinkNo(linkNo)
            commit('addNextQuestion', {
              index: state.index + 1,
              question: nextQuestion.id,
            })
            commit('incrementIndex')
            setTimeout(() => {
              commit('moving', false)
            }, 300)
          })
        } else {
          commit('transition', 'slide-fade')
          Vue.nextTick().then(() => {
            commit('moving', true)
            commit('trimQuestion', {
              index: state.index + 1,
            })
            let type = question.link[`${answer}res`]
            commit('setType', type)
            setTimeout(() => {
              commit('moving', false)
            }, 300)
          })
        }
      }
    },
    movePrevQuestion({ commit, state }) {
      if (state.index != null && state.index > 0) {
        commit('transition', 'fade')
        Vue.nextTick().then(() => {
          commit('moving', true)
          commit('decrementIndex')
          setTimeout(() => {
            commit('moving', false)
          }, 300)
        })
      }
    },
    moveNextQuestion({ commit, state }) {
      if (state.index != null && state.index < state.answers.length - 1) {
        commit('transition', 'fade')
        Vue.nextTick().then(() => {
          commit('moving', true)
          commit('incrementIndex')
          setTimeout(() => {
            commit('moving', false)
          }, 300)
        })
      }
    },
    moveQuestion({ commit, state }, index) {
      if (state.index != index) {
        commit('transition', 'fade')
        Vue.nextTick().then(() => {
          commit('moving', true)
          commit('setIndex', index)
          setTimeout(() => {
            commit('moving', false)
          }, 300)
        })
      }
    },
    moveResult({ commit, state }) {
      if (state.index != null) {
        commit('transition', 'slide-fade')
        Vue.nextTick().then(() => {
          commit('moving', true)
          commit('setIndex', null)
          setTimeout(() => {
            commit('moving', false)
          }, 300)
        })
      }
    }
  },
  mutations: {
    start(state) {
      state.started = true
    },
    moving(state, bool) {
      state.moving = bool
    },
    transition(state, transition) {
      state.transition = transition
    },
    incrementIndex(state) {
      state.index++
    },
    decrementIndex(state) {
      state.index--
    },
    setIndex(state, index) {
      state.index = index
    },
    setQuestions(state, questions) {
      state.questions = questions
    },
    setQuestionAnswer(state, { index, question, answer }) {
      state.answers.splice(index, 1, { question, answer })
      state.type = null
    },
    addNextQuestion(state, { index, question }) {
      state.answers.splice(index)
      state.answers.push({ question, answer: null })
    },
    trimQuestion(state, { index }) {
      state.answers.splice(index)
    },
    setTypes(state, types) {
      state.types = types
    },
    setType(state, type) {
      state.index = null
      state.type = type
    },
    setTypeAnswer(state, { id, answer }) {
      let index = state.types.findIndex(type => type.id == id)
      if (index != -1) {
        state.types.splice(index, 1, {
          ...state.types[index],
          answer,
        })
      }
    }
  },
  modules: {
  },
  strict: debug,
  plugins: [],
})



// WEBPACK FOOTER //
// ./assets/js/store/index.js